module.exports = __webpack_public_path__ + "media/images/countrysquared/lk-62369c8e83a6da8ed5ed5b5eeabf41dd.svg";